<template>
	<div id="app">
		<el-container>
			<!-- 顶部栏 -->
			<el-header style="padding: 0;height: 750px !important;background-color: #fff;" v-if="$route.path=='/'">
				<navHead ref="navHead"></navHead>
			</el-header>
			<el-header style="padding: 0;height: 400px !important;background-color: #fff;" v-else>
				<navHead ref="navHead"></navHead>
			</el-header>
			<!-- 中心 -->
			<el-container >
				<el-main style="padding: 0">
					<router-view :key="$route.fullPath"></router-view>
				</el-main>
			</el-container>
			<!-- 顶部栏 -->
			<el-footer style="padding: 0;">
				<navFooter ref="navFooter"></navFooter>
			</el-footer>
		</el-container>
	</div>
</template>

<script>
	import navHead from '@/components/common/navHead'
	import navFooter from '@/components/common/navFooter'
	export default {
		components: {
			navHead,
			navFooter
		},
		data() {
			return {
				clientHeight: document.documentElement.clientHeight + 'px', //屏幕高度
				dynamicHeight: document.documentElement.clientHeight - 60 + 'px', //屏幕高度  
				login: false
			}
		},
		// 检测路由变化
		watch: {
			$route() {}
		},
		mounted() {
			if (this._isMobile()) {
				// alert("手机端");
				console.log('手机端')
				// this.$router.replace('/mi');
					// window.location.href = 'http://tianhong.shandonghuixing.com/mobile';
					window.location.href = 'http://www.tihondan.com/mobile';


					// window.location.href = 'http://www.tihondan.com/mobileen';
			} else {
				// alert("pc端");
				console.log('pc端')
				// this.$router.replace('/test');
				
			}
		},
		methods: {
			_isMobile() {
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				return flag;
			}
		},
	}
</script>
<style lang="scss">
	@import url("assets/css/ume.css");

	#app {
		background-color: #FFFFFF;
	}
	body::-webkit-scrollbar {
		display: none;
	}
	.el-main::-webkit-scrollbar {
		display: none;
	}

	.isOver {
		width: 100%;
		text-align: center;
		font-size: 18px;
		color: rgba(0, 0, 0, .4);
		padding: 20px;
	}
	.el-carousel__button{
		display: block;
		opacity: .1;
		width: 30px;
		height:4px;
		border: none;
		outline: 0;
		padding: 0;
		margin: 0;
		cursor: pointer;
		-webkit-transition: .3s;
		transition: .3s;
		background-color: #004098!important;
	}
	.el-image__inner, .el-image__placeholder{
		width: 100%;
		height: auto;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue